var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{directives:[{name:"focus",rawName:"v-focus",value:(_vm.focus),expression:"focus"}],staticClass:"S-form-input",class:{ 'S-form-input--invalid': _vm.error },attrs:{"autocomplete":_vm.autocomplete},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.handleInput($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }